import { Button, type ButtonProps } from "react-bootstrap";
import { MdDone } from "react-icons/md";

const DoneButton: TTButtonProps = ({ children, ...props }) => (
  <Button variant="secondary" {...(props as ButtonProps)}>
    <MdDone /> {children}
  </Button>
);

export default DoneButton;
